import { render, staticRenderFns } from "./PICMetriche.vue?vue&type=template&id=e706bf7a&scoped=true"
import script from "./PICMetriche.vue?vue&type=script&lang=js"
export * from "./PICMetriche.vue?vue&type=script&lang=js"
import style0 from "./PICMetriche.vue?vue&type=style&index=0&id=e706bf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706bf7a",
  null
  
)

export default component.exports